'use strict';

designerOpener.$inject = ['mx.shell.NotificationService', 'mx.internationalization'];
export default function designerOpener(notificationService, internationalization) {
	window.mx = window.mx || {};

	return {
		open: openDesigner,
		formUrl: formUrl,
	};

	function openDesigner(type, id) {
		var designerWindow = window.mx.designerWindow;

		if (designerWindow && !designerWindow.closed && designerWindow.location.pathname.indexOf(id) > -1) {
			// This notification is needed for Browsers
			// That doesn't support window.focus() method
			// Or it is disabled because of security reasons.
			notificationService.info(internationalization.get('solutionBuilderAgent.errors.layout_designer_is_opened_already'));
			designerWindow.focus();
		} else {
			window.mx.designerWindow = window.open(formUrl(type, id));
		}
	}

	function formUrl(type, id) {
		return './designer/' + type + '/' + id;
	}
}
